import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyledTitle = styled.div`
  padding: 1.125rem 0.9375rem;
  border-radius: 0.625rem;

  ${fontQuicksand()};
  font-size: 1.25rem;
  color: ${Colors.BLUE};

  margin-bottom: 0.5rem;
`;
